const StaticDemoPage = () => {
  return <h2>test</h2>
}

export default StaticDemoPage
